import { UtemConfig } from "./utem.config"

export const config = new UtemConfig()
